export class BaseModel {
    public id: string = null;
	public deleted: boolean = false;
	public createdDate:string = null;
	public updatedDate: string = null;
	
}